export const editorConfigOptions = {
  uploader: {
    insertImageAsBase64URI: true,
    maxFileSize: 1024 * 1024 * 0.1,
    url: "about:blank",
    imagesExtensions: [
      "jpg",
      "png",
      "jpeg",
      "gif",
      "bmp",
      "svg",
      "webp",
      "avif",
    ],
  },
  controls: {
    font: {
      list: {
        "Tajawal,Arial,sans-serif": "Tajawal",
        "Nunito,Arial,sans-serif": "Nunito",
      },
    },
  },

  inline: true,
  language: "ar",
  minHeight: 400,
  placeholder: "",
  direction: "rtl",
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  toolbarInlineForSelection: true,
  buttons:
    "bold,italic,underline,strikethrough,eraser,ul,ol,font,fontsize,paragraph,lineHeight,image,selectall,hr,table,link,indent,outdent,undo,redo,fullsize,brush,align",
};
